const LOAD_ERROR = 'Yandex map not found';

// загрузчик попадает в несколько бандлов, состояние модуля у каждой копии своё
const LOAD_PROMISE_KEY = 'ymapsLoadPromise';

let loaderScript = null;

function removeLoaderScript() {
    if (loaderScript != null) {
        loaderScript.remove();
        loaderScript = null;
    }
}

function createLoadPromise(src) {
    return new Promise((resolve, reject) => {
        const fail = () => reject(new Error(LOAD_ERROR));
        const resolveWhenReady = () => ymaps.ready(() => resolve(window.ymaps), fail);

        if (window.ymaps != null) {
            resolveWhenReady();
            return;
        }

        loaderScript = document.createElement('script');
        loaderScript.onload = () => (window.ymaps != null ? resolveWhenReady() : fail());
        loaderScript.onerror = fail;
        loaderScript.src = src;
        document.body.appendChild(loaderScript);
    });
}

export function loadYmapsScript(src) {
    if (window[LOAD_PROMISE_KEY] == null) {
        const promise = createLoadPromise(src);
        window[LOAD_PROMISE_KEY] = promise;
        promise.catch(() => {
            if (window[LOAD_PROMISE_KEY] === promise) {
                window[LOAD_PROMISE_KEY] = null;
                removeLoaderScript();
            }
        });
    }

    return window[LOAD_PROMISE_KEY];
}
